import { del, get, post } from "@/common/authentication/API";
import store from "@/store/store";

export function getAllCharacters() {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return get(
    "https://crescent-backend-v2.herokuapp.com/character/List",
    config
  );
}
export function addNewCharacter() {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return post(
    "https://crescent-backend-v2.herokuapp.com/character/List",
    "",
    config
  );
}

export function deleteCharacter(userId: string) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return del(
    `https://crescent-backend-v2.herokuapp.com/character/list?character_id=${userId}`,
    config
  );
}
